export const socialsData = {
  github: "https://github.com/Luke0912",
  linkedIn: "https://linkedin.com/in/shubhamluke09",
  twitter: "https://twitter.com/sortedshubahm",
  medium: "https://medium.com/@shubhamdubey.dubey4",
  youtube: "https://www.youtube.com/channel/UC2EDtavjI4AFdvS0dyxRSRg",
};
